import React, { useEffect } from 'react'
import { useCart } from 'lib/core/hooks'
import { useCartItems } from 'hooks/cart'
import { ListItem } from 'components/Cart/components/ListItem'
import { Container } from './components/Styled'
import { TableHeader } from '../Styled'
import { EmptyContainer, Spinner } from 'lib/ui'
import { useCartContextProvider } from 'components/Cart/components/CartProvider'

export const List = () => {
  const { cart, getCartIsLoading } = useCart()
  const items = cart?.data?.items
  const cartItems = useCartItems(items)
  const isCartLoading = getCartIsLoading()
  const { setSavedCartItem, setCartItemData } = useCartContextProvider()

  useEffect(() => {
    const cartItemsData = cartItems?.reduce((obj: Record<string, any>, cartItem) => {
      if (!obj[cartItem.id]) {
        obj[cartItem.id] = {
          cart_item_id: parseInt(cartItem.id),
          quantity: cartItem.quantity,
          frequency_in_cart: cartItem.frequencyInCart ?? '',
          sku: cartItem.variantProduct?.sku ?? cartItem.product.sku
        }
      }

      return obj
    }, {})
    setSavedCartItem(cartItemsData)
    setCartItemData(cartItemsData)
    // eslint-disable-next-line
  }, [JSON.stringify(cartItems)])

  if (!items) {
    return null
  }

  return (
    <Container>
      <TableHeader>Products</TableHeader>
      {isCartLoading ? (
        <EmptyContainer>
          <Spinner />
        </EmptyContainer>
      ) : (
        <ul>
          {cartItems?.map(cartItem => {
            const SubItem = cartItem?.associatedProduct
            const [sampleDuration] = cartItem.product.customAttribute?.promotion_days ?? []
            if (SubItem?.id) {
              return (
                <>
                  <ListItem
                    isSampleSupply
                    key={cartItem.id}
                    cartItem={cartItem}
                  />
                  <ListItem
                    key={SubItem?.id}
                    cartItem={SubItem}
                    sampleDuration={sampleDuration}
                    isChild
                  />
                </>
              )
            }

            return (
              <ListItem
                key={cartItem?.id}
                cartItem={cartItem}
                cartId={cart?.cartId}
              />
            )
          })}
        </ul>
      )}
    </Container>
  )
}
